import { render, staticRenderFns } from "./championships.vue?vue&type=template&id=a648e46e&scoped=true"
import script from "./championships.vue?vue&type=script&lang=js"
export * from "./championships.vue?vue&type=script&lang=js"
import style0 from "./championships.vue?vue&type=style&index=0&id=a648e46e&prod&l=true&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a648e46e",
  null
  
)

export default component.exports